"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _formGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/form-group.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _formGroup.default);
/** A **FormRadioGroup** is a type of FormGroup that groups a collection of radio buttons or checkboxes into a single input value.
 * **FormRadioItem** is a specialized form control that emits an `<input>` with a type of radio.
 * Radios allow the user to see all options and select one. Generally, this is used when there are
between 2-3 options. This component can also be disabled and displayed in a row. */

var FormRadioGroup = function FormRadioGroup(_ref) {
  var _context;

  var children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      compact = _ref.compact,
      disabled = _ref.disabled,
      inline = _ref.inline,
      _onChange = _ref.onChange;
  var groupId = (0, _useUniqueId.default)();
  var formGroupClasses = classnames("".concat(cssNamespace, "-form-group"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-form-group--inline"), inline), className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: formGroupClasses
  }, (0, _map.default)(_context = _react.default.Children.toArray(children)).call(_context, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      compact: child.props.compact || compact,
      disabled: child.props.disabled || disabled,
      inline: child.props.inline || inline,
      name: child.props.name || groupId,
      onChange: function onChange(e) {
        var _child$props$onChange, _child$props;

        ((_child$props$onChange = (_child$props = child.props).onChange) === null || _child$props$onChange === void 0 ? void 0 : _child$props$onChange.call(_child$props, e, child.props.data)) || _onChange(e, child.props.data);
      }
    });
  }));
};

FormRadioGroup.displayName = 'FormRadioGroup';
process.env.NODE_ENV !== "production" ? FormRadioGroup.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Set to **true** to display radio buttons in a row */
  inline: _propTypes.default.bool,

  /**
   * Callback function; triggered when the selected `FormRadioItem` in the `FormRadioGroup` changes.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {*} radioItemData - anything set on the data property of the last selected FormRadioItem within this group.
   * @returns {void}
  */
  onChange: _propTypes.default.func
} : void 0;
FormRadioGroup.defaultProps = {
  onChange: function onChange() {}
};

var _default = (0, _withStyles.default)(FormRadioGroup);

exports.default = _default;